import { render, staticRenderFns } from "./FoundersAndExperts.vue?vue&type=template&id=743f0aa4&scoped=true&"
import script from "./FoundersAndExperts.vue?vue&type=script&lang=js&"
export * from "./FoundersAndExperts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743f0aa4",
  null
  
)

export default component.exports